import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["input"];

  connect() {
    document.addEventListener('keydown', this.handleKeyPress);
    this.timeout = null;

    // Listen for Turbo Frame load to prefill pills after navigation
    this.boundHandleTurboFrameLoad = this.handleTurboFrameLoad.bind(this)
    document.addEventListener('turbo:frame-load', this.boundHandleTurboFrameLoad);

    // Listen for modal show events to update form actions with current URL params
    $('#saveSearchModal, #updateSearchModal').on('show.bs.modal', this.updateModalFormAction.bind(this));
  }

  disconnect() {
    document.removeEventListener('keydown', this.handleKeyPress);
    document.removeEventListener('turbo:frame-load', this.boundHandleTurboFrameLoad);
    clearTimeout(this.timeout);
    this.cleanupSyncedFields();

    // Remove modal event listeners
    $('#saveSearchModal, #updateSearchModal').off('show.bs.modal');
  }

  cleanupSyncedFields() {
    // Remove any Vue-synced hidden fields when controller disconnects
    const searchForm = document.getElementById('search-form-tab');
    if (searchForm) {
      const syncedFields = searchForm.querySelectorAll('.vue-sync-field');
      syncedFields.forEach(field => field.remove());
    }
  }

  handleKeyPress = (event) => {
    // Check if the pressed key is ESC (key code 27)
    if (event.key === 'Escape') {
      // Close the modal
      $(this.element).modal('hide');
    }
  }

  submitForm() {
    event.preventDefault();
    clearTimeout(this.timeout);
    const currentInputValue = this.inputTarget.value; // Store the current input value

    // Update full_search value in ALL hidden fields across all forms
    const fullSearchInputs = document.querySelectorAll('input[name="ps[full_search]"]');
    fullSearchInputs.forEach(input => {
      input.value = currentInputValue;
    });

    // Also update the visible full_search_hidden field if it exists
    const fullSearchHidden = document.getElementById('full_search_hidden');
    if (fullSearchHidden) {
      fullSearchHidden.value = currentInputValue;
    }

    // Capture Vue.js search clauses data before submitting
    this.captureVueSearchClauses();

    const urlParams = new URLSearchParams(window.location.search);
    const searchScopeId = urlParams.get('search_scope_id');

    this.timeout = setTimeout(() => {
      // Priority 1: Submit inline form if it exists (variants/reports pages)
      const inlineSearchBtn = document.querySelector('#inline-search-submit');
      if (inlineSearchBtn) {
        const inlineForm = inlineSearchBtn.closest('form');
        if (inlineForm && document.contains(inlineForm)) {
          inlineForm.requestSubmit();
          if(searchScopeId){
            this.removeSelect();
          }
          return;
        }
      }

      // Priority 2: Submit advanced search form (fallback for other pages)
      const searchForm = document.getElementById('search-form-tab');
      if (searchForm && document.contains(searchForm)) {
        searchForm.requestSubmit();
        if(searchScopeId){
          this.removeSelect();
        }
      }
    }, 400); // Adjust the delay as needed
  }

  removeSelect(){
    const tabs = document.querySelectorAll(".nav-link"); // Select tabs using class name
  }

  captureVueSearchClauses() {
    // Use shared utility from utils.js
    window.captureVueSearchClauses('vue-sync-field');
  }

  changeSearchValue(event){
    if(event.currentTarget.dataset.targetValue){
      document.getElementById('full_search').value = event.currentTarget.dataset.targetValue
    }else{
      document.getElementById('full_search').value = ""
    }

    const searchForms = document.querySelectorAll('#search-form-tab')
    searchForms.forEach(searchForm => {
      const saveScopeIdField = searchForm.querySelector('input[name="search_scope_id"]')
      if(saveScopeIdField){
        saveScopeIdField.value = ""
      }
    })

    // Store search clauses for prefilling after Turbo navigation
    const searchClausesData = event.currentTarget.dataset.searchClauses
    if (searchClausesData) {
      sessionStorage.setItem('pendingSearchClauses', searchClausesData)
      // Attempt immediate prefill with slight delay
      setTimeout(() => this.tryPrefillPills(), 200)
    }
  }
  
  handleTurboFrameLoad(event) {
    // Prefill pills after search_scopes or search-results-frame loads
    if ((event.target.id === 'search_scopes' || event.target.id === 'search-results-frame') && 
        sessionStorage.getItem('pendingSearchClauses')) {
      setTimeout(() => this.tryPrefillPills(), 100)
    }
  }
  
  tryPrefillPills() {
    const searchClausesData = sessionStorage.getItem('pendingSearchClauses')
    if (!searchClausesData) return
    
    try {
      const searchClauses = JSON.parse(searchClausesData)
      const filterForm = document.querySelector('form[data-controller*="select--advanced-filter"]')
      
      if (!filterForm) return
      
      const filterController = this.application.getControllerForElementAndIdentifier(
        filterForm, 'select--advanced-filter'
      )
      
      if (!filterController) return
      
      // Clear and load search clauses
      filterController.searchClauses = Array.isArray(searchClauses) && searchClauses.length > 0
        ? searchClauses.map(clause => filterController.initializeSearchClause(clause))
        : []
      
      filterController.renderSearchClauses()
      sessionStorage.removeItem('pendingSearchClauses')
    } catch (error) {
      console.error('[SaveSearch] Error prefilling pills:', error)
    }
  }

  updateModalFormAction(event) {
    // Get the modal that's being shown
    const modal = event.target;
    const form = modal.querySelector('form');

    if (!form) return;

    // Get current URL
    const currentUrl = new URL(window.location.href);

    // Get the form's action URL
    const formAction = new URL(form.action, window.location.origin);

    // Clear any existing columns params in the action (can be stale)
    Array.from(formAction.searchParams.keys()).forEach((key) => {
      if (key.startsWith('ps[c]') || key.startsWith('persisted_search[columns]')) {
        formAction.searchParams.delete(key);
      }
    });

    // Copy all persisted_search parameters from current URL to form action
    currentUrl.searchParams.forEach((value, key) => {
      if (key.startsWith('persisted_search[') || key.startsWith('ps[')) {
        // Skip columns parameter - we'll get it from the form instead
        if (!key.startsWith('persisted_search[columns]') && !key.startsWith('ps[c]')) {
          formAction.searchParams.set(key, value);
        }
      }
    });

    const searchForm = document.getElementById('search-form-tab');
    if (searchForm) {
      const columnCheckboxes = searchForm.querySelectorAll('input[type="checkbox"][name^="ps[c]"], input[type="checkbox"][name^="persisted_search[columns]"]');
      
      columnCheckboxes.forEach(checkbox => {
        // Only include checked columns
        if (checkbox.checked) {
          // Extract column name from checkbox name attribute
          // name format: ps[c][column_name] or persisted_search[columns][column_name]
          const match = checkbox.name.match(/(?:ps\[c\]|persisted_search\[columns\])\[([^\]]+)\]/);
          if (match) {
            const columnName = match[1];
            formAction.searchParams.set(`ps[c][${columnName}]`, '1');
          }
        }
      });
    }

    // Update the form action with current params
    form.action = formAction.toString();
  }
}
